'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.watchOpen = watchOpen;
exports.watchDispatchOnOpening = watchDispatchOnOpening;
exports.watchCall = watchCall;
exports.watchPublish = watchPublish;
exports.watchSubscribe = watchSubscribe;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _lodash = require('lodash');

var _socket = require('../api/socket');

var socketApi = _interopRequireWildcard(_socket);

var _socket2 = require('../actions/socket');

var socketActions = _interopRequireWildcard(_socket2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = [openWorker, dispatchOnOpeningWorker, putQueuedActionsWorker, callWorker, publishWorker, subscribeWorker, watchOpen, watchDispatchOnOpening, watchCall, watchPublish, watchSubscribe].map(regeneratorRuntime.mark);

/**
 *	Opens a connection to a websocket at the given URL.
 */
function openWorker(_ref) {
	var url = _ref.payload.url;
	var session;
	return regeneratorRuntime.wrap(function openWorker$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					_context.prev = 0;
					_context.next = 3;
					return (0, _effects.call)(socketApi.open, url);

				case 3:
					session = _context.sent;
					_context.next = 6;
					return (0, _effects.put)(socketActions.setSession(session));

				case 6:
					_context.next = 8;
					return (0, _effects.put)(socketActions.opened());

				case 8:
					_context.next = 10;
					return (0, _effects.call)(putQueuedActionsWorker);

				case 10:
					_context.next = 16;
					break;

				case 12:
					_context.prev = 12;
					_context.t0 = _context['catch'](0);
					_context.next = 16;
					return (0, _effects.put)(socketActions.closed(_context.t0));

				case 16:
				case 'end':
					return _context.stop();
			}
		}
	}, _marked[0], this, [[0, 12]]);
}

/**
 *	Puts the given action if the connection is open, otherwise
 *	queues it to put it when the connection opens.
 */
function dispatchOnOpeningWorker(_ref2) {
	var action = _ref2.payload.action;
	var session, effect;
	return regeneratorRuntime.wrap(function dispatchOnOpeningWorker$(_context2) {
		while (1) {
			switch (_context2.prev = _context2.next) {
				case 0:
					_context2.next = 2;
					return (0, _effects.select)((0, _lodash.property)('vtChat.socket.session'));

				case 2:
					session = _context2.sent;
					effect = session ? (0, _effects.put)(action) : (0, _effects.put)(socketActions.queueAction(action));
					_context2.next = 6;
					return effect;

				case 6:
				case 'end':
					return _context2.stop();
			}
		}
	}, _marked[1], this);
}

/**
 *	Puts all queued actions and clears the queue.
 */
function putQueuedActionsWorker() {
	var actions;
	return regeneratorRuntime.wrap(function putQueuedActionsWorker$(_context3) {
		while (1) {
			switch (_context3.prev = _context3.next) {
				case 0:
					_context3.next = 2;
					return (0, _effects.select)((0, _lodash.property)('vtChat.socket.actionQueue'));

				case 2:
					actions = _context3.sent;
					_context3.next = 5;
					return actions.map(function (action) {
						return (0, _effects.put)(action);
					});

				case 5:
					_context3.next = 7;
					return (0, _effects.put)(socketActions.clearActionQueue());

				case 7:
				case 'end':
					return _context3.stop();
			}
		}
	}, _marked[2], this);
}

/**
 *	Makes an RPC call and exposes the result as an action.
 */
function callWorker(_ref3) {
	var payload = _ref3.payload;
	var _ref3$meta = _ref3.meta;
	var uri = _ref3$meta.uri;
	var actionCreator = _ref3$meta.actionCreator;
	var session, response, action;
	return regeneratorRuntime.wrap(function callWorker$(_context4) {
		while (1) {
			switch (_context4.prev = _context4.next) {
				case 0:
					_context4.next = 2;
					return (0, _effects.select)((0, _lodash.property)('vtChat.socket.session'));

				case 2:
					session = _context4.sent;

					if (session) {
						_context4.next = 5;
						break;
					}

					return _context4.abrupt('return');

				case 5:
					_context4.prev = 5;
					_context4.next = 8;
					return (0, _effects.call)(session.call.bind(session), uri, payload);

				case 8:
					response = _context4.sent;
					action = actionCreator(response);
					_context4.next = 12;
					return (0, _effects.put)(action);

				case 12:
					_context4.next = 17;
					break;

				case 14:
					_context4.prev = 14;
					_context4.t0 = _context4['catch'](5);

					console.error('RPC error at "' + uri + '":', _context4.t0); // eslint-disable-line no-console

				case 17:
				case 'end':
					return _context4.stop();
			}
		}
	}, _marked[3], this, [[5, 14]]);
}

/**
 *	Publishes data to the given channel.
 */
function publishWorker(_ref4) {
	var _ref4$payload = _ref4.payload;
	var type = _ref4$payload.type;
	var data = _ref4$payload.data;
	var channel = _ref4.meta.channel;
	var session;
	return regeneratorRuntime.wrap(function publishWorker$(_context5) {
		while (1) {
			switch (_context5.prev = _context5.next) {
				case 0:
					_context5.next = 2;
					return (0, _effects.select)((0, _lodash.property)('vtChat.socket.session'));

				case 2:
					session = _context5.sent;

					if (!session) {
						_context5.next = 6;
						break;
					}

					_context5.next = 6;
					return (0, _effects.call)(session.publish.bind(session), channel, {
						type: type,
						data: data
					});

				case 6:
				case 'end':
					return _context5.stop();
			}
		}
	}, _marked[4], this);
}

/**
 *	Polls events on the given channel, using actionCreator to
 *	dispatch actions from the received data.
 *
 *	@param {string} channel - Channel name.
 *	@param {function} actionCreator - Action creator.
 */
function subscribeWorker(_ref5) {
	var _ref5$meta = _ref5.meta;
	var channel = _ref5$meta.channel;
	var actionCreator = _ref5$meta.actionCreator;

	var session, events, _ref6, type, data, action;

	return regeneratorRuntime.wrap(function subscribeWorker$(_context6) {
		while (1) {
			switch (_context6.prev = _context6.next) {
				case 0:
					_context6.next = 2;
					return (0, _effects.select)((0, _lodash.property)('vtChat.socket.session'));

				case 2:
					session = _context6.sent;

					if (session) {
						_context6.next = 5;
						break;
					}

					return _context6.abrupt('return');

				case 5:
					events = (0, _reduxSaga.eventChannel)(function (emit) {
						session.subscribe(channel, function (_, data) {
							return emit(data);
						});
						return session.unsubscribe.bind(null, channel);
					});

				case 6:
					if (!true) {
						_context6.next = 24;
						break;
					}

					_context6.prev = 7;
					_context6.next = 10;
					return (0, _effects.take)(events);

				case 10:
					_ref6 = _context6.sent;
					type = _ref6.type;
					data = _ref6.data;
					action = actionCreator(type, data);

					if (!action) {
						_context6.next = 17;
						break;
					}

					_context6.next = 17;
					return (0, _effects.put)(action);

				case 17:
					_context6.next = 22;
					break;

				case 19:
					_context6.prev = 19;
					_context6.t0 = _context6['catch'](7);

					console.error('Subscription error on "' + channel + '":', _context6.t0); // eslint-disable-line no-console

				case 22:
					_context6.next = 6;
					break;

				case 24:
				case 'end':
					return _context6.stop();
			}
		}
	}, _marked[5], this, [[7, 19]]);
}

/**
 *
 */
function watchOpen() {
	return regeneratorRuntime.wrap(function watchOpen$(_context7) {
		while (1) {
			switch (_context7.prev = _context7.next) {
				case 0:
					_context7.next = 2;
					return (0, _reduxSaga.takeLatest)(socketActions.OPEN, openWorker);

				case 2:
				case 'end':
					return _context7.stop();
			}
		}
	}, _marked[6], this);
}

/**
 *
 */
function watchDispatchOnOpening() {
	return regeneratorRuntime.wrap(function watchDispatchOnOpening$(_context8) {
		while (1) {
			switch (_context8.prev = _context8.next) {
				case 0:
					_context8.next = 2;
					return (0, _reduxSaga.takeEvery)(socketActions.DISPATCH_ON_OPENING, dispatchOnOpeningWorker);

				case 2:
				case 'end':
					return _context8.stop();
			}
		}
	}, _marked[7], this);
}

/**
 *
 */
function watchCall() {
	return regeneratorRuntime.wrap(function watchCall$(_context9) {
		while (1) {
			switch (_context9.prev = _context9.next) {
				case 0:
					_context9.next = 2;
					return (0, _reduxSaga.takeEvery)(socketActions.CALL, callWorker);

				case 2:
				case 'end':
					return _context9.stop();
			}
		}
	}, _marked[8], this);
}

/**
 *
 */
function watchPublish() {
	return regeneratorRuntime.wrap(function watchPublish$(_context10) {
		while (1) {
			switch (_context10.prev = _context10.next) {
				case 0:
					_context10.next = 2;
					return (0, _reduxSaga.takeEvery)(socketActions.PUBLISH, publishWorker);

				case 2:
				case 'end':
					return _context10.stop();
			}
		}
	}, _marked[9], this);
}

/**
 *
 */
function watchSubscribe() {
	return regeneratorRuntime.wrap(function watchSubscribe$(_context11) {
		while (1) {
			switch (_context11.prev = _context11.next) {
				case 0:
					_context11.next = 2;
					return (0, _reduxSaga.takeEvery)(socketActions.SUBSCRIBE, subscribeWorker);

				case 2:
				case 'end':
					return _context11.stop();
			}
		}
	}, _marked[10], this);
}